<template>
    <div class="order-wrap">
        <div class="order-head">
            <div class="order-item">
                <span class="name">商品名称</span>
                <span class="order-no">订单号</span>
                <span class="paytime">支付时间</span>
                <span class="pay-money">支付金额</span>
                <span class="order-status">
                    <FilterPick class="pick-item" :data="orderStatusList" :titleKey="'name'" :pickIndex.sync="statusIndex" key="type"> </FilterPick>
                </span>
                <div class="group-status" v-if="type === 0">拼团状态</div>
                <span class="op-label">操作</span>
            </div>
        </div>
        <div class="order-body">
            <div class="order-item" v-for="item in orderList" :key="item.order_no">
                <span class="name">
                    <template v-if="item.group_id > 0">
                        {{ `${item.g_name}（2人拼团）` }}
                    </template>
                    <template v-else-if="orderQuery.type === 0">
                        {{ item.g_name }}
                    </template>
                    <template v-else-if="orderQuery.type == 1">
                        {{ item.type === 1 ? item.goodsname : item.g_name }}
                    </template>
                    <template v-else> {{ item.g_name }}--{{ item.gs_name }} </template>
                </span>
                <span class="order-no">{{ item.order_no }}</span>
                <span class="paytime">{{ item.pay_time == '0001-01-01 00:00:00' ? '--' : item.pay_time }}</span>
                <span class="pay-money">¥{{ item.total_price }}</span>
                <span class="order-status">{{ orderStatus[item.status] }}</span>
                <span class="group-status" v-if="type === 0">{{ item.group_id > 0 ? groupStatus[item.group_status] : '--' }}</span>
                <span class="op-label">
                    <div class="op-div" @click="contactCustomer">联系客服</div>
                    <div class="op-div" v-if="item.status == 1 && item.group_id > 0 && item.group_status === 1" @click="showGroupVip(item)">分享链接</div>
                    <div class="op-div" v-if="item.order_type == 'SH'" @click="showAccountInfo(item)">查看账号</div>
                </span>
            </div>
            <div class="loading-data" v-if="loading"></div>
            <div class="no-order-data" v-if="(!orderList.length && loadingFinish) || (orderQuery.page == 1 && loadingError)">
                <span>暂无订单</span>
            </div>
        </div>
    </div>
</template>
<script>
import { getVipOrder, getAccountOrder } from '@/http/api/order'
import store from '@/store/store.js'
import { getGroupInfo } from '@/http/api/activity'
import FilterPick from '@/components/FilterPick.vue'

// 订单状态筛选项
const orderStatusList = [
    { id: 99, name: '全部' },
    { id: 1, name: '已支付' },
    { id: 2, name: '申诉中' },
    { id: 3, name: '申诉成功' },
    { id: 4, name: '退款中' },
    { id: 5, name: '申诉失败' },
    { id: 6, name: '退款失败' },
    { id: 7, name: '退款成功' }
]

const orderStatus = {
    0: '未支付',
    1: '已支付',
    2: '申诉中',
    3: '申诉成功',
    4: '退款中',
    5: '申诉失败',
    6: '退款失败',
    7: '退款成功',
    8: '已关闭'
}

// 拼团状态
const groupStatus = {
    0: '待支付',
    1: '正在拼团中',
    2: '拼团成功',
    3: '拼团失败'
}

export default {
    name: 'order-list',
    components: { FilterPick },
    props: {
        type: {
            type: Number,
            required: true,
            default: 0
        }
    },
    data() {
        return {
            orderStatusList,
            orderStatus,
            groupStatus,
            orderList: [],
            statusIndex: 0,
            orderQuery: {
                page: 1,
                size: 30,
                status: 99,
                type: 0
            },
            loading: false,
            loadingFinish: false,
            loadingError: false,
            queryGroupInfoTimes: 0
        }
    },
    computed: {
        customerLink: function () {
            return store.getters.customerLink
        },
        filterItemStatus() {
            return (item) => {
                let statusItem = this.orderStatusList.find((v) => v.id === item.status)
                return statusItem ? statusItem.name : '--'
            }
        }
    },
    watch: {
        type: {
            immediate: true,
            handler(newValue) {
                clearTimeout(this.queryGroupOrderStatusTimeId)
                this.queryGroupInfoTimes = 0
                this.orderQuery.type = newValue
                this.resetData()
                this.getOrderData()
            }
        },
        statusIndex: {
            handler(cur) {
                const id = this.orderStatusList[cur].id
                this.orderQuery.status = id
                this.orderQuery.page = 1
                this.orderList = []
                this.loading = false
                this.loadingFinish = false
                this.loadingError = false
                this.queryGroupInfoTimes = 0
                clearTimeout(this.queryGroupOrderStatusTimeId)
                this.getOrderData()
            }
        }
    },
    mounted() {
        this.$EventBus.$on('update-group-order', this.updateGroupOrder)
        this.$EventBus.$on('loop-query-group-order', this.loopGroupOrder)

        if (this.type === 0 || this.type === 1) {
            this.orderQuery.status = 99
            this.statusIndex = 0
        } else if (this.type === 2) {
            this.orderQuery.status = 1
            this.statusIndex = 1
        }
    },
    beforeDestroy() {
        clearTimeout(this.queryGroupOrderStatusTimeId)
        this.$EventBus.$off('update-group-order', this.updateGroupOrder)
        this.$EventBus.$off('loop-query-group-order', this.loopGroupOrder)
    },
    methods: {
        resetData() {
            this.orderQuery.page = 1
            this.orderQuery.status = 99
            this.orderList = []
            this.loading = false
            this.loadingFinish = false
            this.loadingError = false
        },
        getOrderData() {
            this.loading = true

            if (this.type == 0 || this.type == 1) {
                this.getOrder = getVipOrder
            } else if (this.type == 2) {
                this.getOrder = getAccountOrder
            }

            this.getOrder(this.orderQuery)
                .then((res) => {
                    this.loading = false
                    if (res.code == 200 && this.$Utils.isObject(res.data) && Array.isArray(res.data.list)) {
                        this.orderList = [...this.orderList, ...res.data.list]
                            .reduce((acc, current) => {
                                if (!acc.some((item) => item.id === current.id)) {
                                    acc.push(current)
                                }
                                return acc
                            }, [])
                            .map((v) => {
                                let external_content = {},
                                    tempObj = { ...v }
                                try {
                                    external_content = JSON.parse(v.external_content)
                                    tempObj.gs_name = external_content.s_name
                                } catch (error) {}
                                return tempObj
                            })
                        if (this.orderQuery.size > res.data.list.length) {
                            this.loadingFinish = true
                        }

                        this.loopGroupOrder()
                    } else {
                        this.loadingError = true
                    }
                })
                .catch(() => {
                    this.loading = false
                    this.loadingError = true
                })
        },
        // 滚动加载更多商品
        scrollLoadMore() {
            let that = this
            let nDivHight = $('.vip-order-content .order-body').innerHeight() // 包括内填充高度
            $('.vip-order-content .order-body').scroll(function () {
                if (that.loading) {
                    return false
                }
                if (that.loadingError) {
                    return false
                }
                let nScrollHight = $(this)[0].scrollHeight
                let nScrollTop = $(this)[0].scrollTop
                if (nScrollTop + nDivHight >= nScrollHight - 50) {
                    if (!that.loading && !that.loadingFinish) {
                        // 不在加载数据中，并且还没有加载全部数据
                        if (!that.loadingError) {
                            that.orderQuery.page++
                        }
                        that.getOrderData()
                    }
                }
            })
        },
        closeVipOrder() {
            this.isShow = false
        },
        contactCustomer() {
            window.open(store.getters.customerLink, '_blank')
        },
        changeOrderType(item) {
            this.orderQuery.page = 1
            this.orderQuery.status = 1
            this.orderQuery.type = item.value
            this.orderList = []
            this.loading = false
            this.loadingFinish = false
            this.loadingError = false

            this.getOrderData()
        },
        showAccountInfo(item) {
            this.$BuyAccountInfo.show(item.order_no)
        },
        showGroupVip(item) {
            if (item.group_id <= 0) {
                return false
            }

            getGroupInfo({ id: item.group_id }).then((res) => {
                if (res.code === 200 && this.$Utils.isObject(res.data)) {
                    const { status, goods_info } = res.data
                    if (status === 1) {
                        this.$BuyGroupVip.show({
                            type: 2,
                            showContentType: -998,
                            goods: goods_info
                        })
                        clearTimeout(this.queryGroupOrderStatusTimeId)
                    } else {
                        this.$set(item, 'group_status', status)
                    }
                } else {
                    this.$Toast.show('获取订单拼团信息失败，请稍后再试')
                }
            })
        },
        updateGroupOrder(data) {
            if (this.type !== 0) {
                return
            }

            const { id, status } = data
            const orderItem = this.orderList.find((item) => item.group_id === id)
            if (orderItem) {
                if (status !== 1) {
                    this.$set(orderItem, 'group_status', status)
                }
            }
        },
        // 查询是否含有“拼团中”的订单
        loopGroupOrder() {
            const groupOrder = this.orderList.find((item) => item.group_id > 0 && item.group_status === 1)
            if (groupOrder) {
                this.loopQueryGroupOrderStatus(groupOrder)
            }
        },
        loopQueryGroupOrderStatus(item) {
            clearTimeout(this.queryGroupOrderStatusTimeId)
            let timeCell = 1000
            this.queryGroupInfoTimes++

            // 根据查询的次数
            if (this.queryGroupInfoTimes < 60) {
                timeCell = 1000
            } else if (this.queryGroupInfoTimes < 120) {
                timeCell = 1500
            } else if (this.queryGroupInfoTimes < 180) {
                timeCell = 2000
            } else if (this.queryGroupInfoTimes < 240) {
                timeCell = 2500
            } else {
                timeCell = 3000
            }
            getGroupInfo({ id: item.group_id }).then((res) => {
                if (res.code === 200 && this.$Utils.isObject(res.data)) {
                    const { status, order_status } = res.data
                    if (status === 1 && (order_status === 1 || order_status === 6)) {
                        this.queryGroupOrderStatusTimeId = setTimeout(() => {
                            this.loopQueryGroupOrderStatus(item)
                        }, timeCell)
                    } else {
                        this.$set(item, 'group_status', status)
                    }
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.order-wrap {
    height: 100%;

    .order-head {
        height: 50px;
        background: rgba(0, 0, 0, 0.23);
        font-size: @font-size-medium;
        color: #ccc;

        .order-item {
            height: 100%;

            .name {
                padding-left: 54px;
            }
        }

        .order-status {
            position: relative;
            display: flex;
            justify-content: center;

            /deep/ .filter-item {
                background: none;
                width: 100px;
                padding: 0 10px;
                border: 1px solid #333;

                .filter-title {
                    padding: 0;
                    text-align: center;
                    font-size: 14px;
                    width: 63px;
                    color: #ccc;
                }
            }
        }

        .op-label {
            text-align: center;
        }
    }

    .order-body {
        height: calc(100% - 60px);
        font-size: @font-size-normal;
        color: @color-txt-normal;

        overflow-y: auto;
        position: relative;

        &.visible {
            overflow-y: visible;
        }

        &::-webkit-scrollbar {
            width: 0;
        }

        span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .order-item:nth-child(2n) {
            background: rgba(255, 255, 255, 0.07);
        }

        .order-item {
            .op-label {
                align-items: flex-center;
                text-decoration: underline;
                color: @main-green-color;
                cursor: pointer;
            }
        }
    }

    .order-item {
        display: flex;
        height: 56px;
        align-items: center;

        span {
            flex-shrink: 0;
        }

        .name {
            flex: 1;
            padding-left: 30px;
            width: 140px;
        }

        .order-no {
            width: 19%; // 224px;
            padding-right: 40px;
            text-align: center;
        }

        .paytime {
            width: 15.3%; // 190px;
            text-align: center;
        }

        .pay-money {
            width: 15%; // 185px;
            text-align: center;
        }

        .order-status {
            width: 12.2%; // 93px;
            text-align: center;
        }

        .group-status {
            width: 12.2%; // 93px;
            text-align: center;
        }

        .op-label {
            margin: 0 36px 0 20px;
            width: 10%; // 100px;
            line-height: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
        }
    }

    .loading-data {
        margin: 0 auto;
        width: 80px;
        height: 43px;
        background-size: 100% 100%;
    }

    .no-order-data {
        position: absolute;
        top: 25%;
        left: 50%;
        transform: translateX(-50%);
        width: 168px;
        height: 168px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;

        span {
            position: absolute;
            font-size: 16px;
            left: 50%;
            transform: translateX(-50%);
            bottom: -42px;
            color: rgba(255, 255, 255, 0.5);
        }
    }
}
</style>
